import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { ExtraResponsibilityCreateType } from "@type/HRM/employees";

import { STATUS } from "@constants/status.hrm";

const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const getEmployee = (() => {
  return async (id: number) => {
    return api
      .get(`${apiEndPoint}/${id}/general-info`)
      .then((response) => response.data);
  };
})();

export const createExtraResponsibility = (() => {
  return async (
    formData: ExtraResponsibilityCreateType,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .post(`${apiEndPoint}/temp/account/request`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const acceptExtraResponsibility = (() => {
  return async (
    employeeID: number,
    tempAccountId: number,
    formData: ExtraResponsibilityCreateType,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .post(
        `${apiEndPoint}/${employeeID}/temp/account/${tempAccountId}/approve`,
        {
          ...formData,
        },
      )
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
          message: response.data.message,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
          message: response.response.data.message,
        });

        return { data: response.data };
      });
  };
})();

export const deleteExtraResponsibility = (() => {
  return async (
    employeeID: string | number,
    serviceEndDate: string,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .delete(`${apiEndPoint}/${employeeID}/temp/account/delete`, {
        data: {
          serviceEndDate,
        },
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
          message: response.data.message,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
          message: response.response.data.message,
        });

        return { data: response.data };
      });
  };
})();

export const changeAccountStatus = (() => {
  return async (
    employeeID: string | number,
    isActive: boolean,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .put(`${apiEndPoint}/${employeeID}/active`, {
        isActive: isActive ? false : true,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
          message: response.data.message,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
          message: response.response.data.message,
        });

        return { data: response.data };
      });
  };
})();
